import BaseReducer from '../../utilities/BaseReducer';
import ITransferState from './models/ITransferState';
import ChallengeAction from './ChallengeAction';
import TransferModel from './models/TransferModel';
import OperationModel from './models/OperationModel';
import IAction from '../../models/IAction';

export default class ChallengeReducer extends BaseReducer<ITransferState> {
    public readonly initialState: ITransferState = {
        transferFxn: null,
        operationFxn: null,
        queryString: null,
        currentTransaction: '',
        transactionOnInit: false,
        counter: 0,
    };

    public [ChallengeAction.REQUEST_DO_TRANSFER_FXN_FINISHED](state: ITransferState, action: IAction<TransferModel>): ITransferState {
        return {
            ...state,
            transferFxn: action.payload!,
        };
    }

    public [ChallengeAction.SET_QUERY_STRING](state: ITransferState, action: IAction<[]>): ITransferState {
        return {
            ...state,
            queryString: action.payload!,
        };
    }

    public [ChallengeAction.REQUEST_DO_OPERATION_FXN_FINISHED](state: ITransferState, action: IAction<OperationModel>): ITransferState {
        return {
            ...state,
            operationFxn: action.payload!,
        };
    }

    public [ChallengeAction.SET_CURRENT_TRANSACTION](state: ITransferState, action: IAction<string>): ITransferState {
        return {
            ...state,
            currentTransaction: action.payload,
        };
    }

    public [ChallengeAction.SET_TRANSACTION_ONINIT](state: ITransferState, action: IAction<boolean>): ITransferState {
        return {
            ...state,
            transactionOnInit: action.payload!,
        };
    }

    public [ChallengeAction.SET_COUNTER](state: ITransferState, action: IAction<number>): ITransferState {
        return {
            ...state,
            counter: action.payload!,
        };
    }
}
